import { Components, Theme } from '@mui/material/styles';

import { typography13MediumStyle } from 'src/legacy/components/Text';

const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: 20,
      borderRadius: theme.shape.borderRadius,
      border: 'none',
      padding: 0,
      '& > span:first-of-type': {
        padding: '0px 5px',
        ...typography13MediumStyle,
        // chip label line height should not exceed
        // the root wrapper height.
        lineHeight: '20px',
      },
    }),
    colorPrimary: ({ theme }) => ({
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    }),
  },
};

export default MuiChip;
